import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { UPLOAD_REQUIREMENT_SECTIONS } from '../utils/uploadRequirements';

// Always-visible — never collapsed behind a click, so requirements are
// discoverable without extra interaction.
export default function UploadRequirementsPanel() {
  return (
    <div style={s.wrap}>
      <div style={s.header}>
        <FontAwesomeIcon icon={faCircleInfo} style={{ color: 'var(--accent)' }} aria-hidden="true" />
        <span style={s.headerTitle}>Upload Requirements</span>
      </div>
      {UPLOAD_REQUIREMENT_SECTIONS.map(section => {
        const isTips = section.title === 'Best Practices';
        return (
          <div key={section.title} style={s.section}>
            <div style={s.sectionTitle}>{section.title}</div>
            {isTips ? (
              <div style={s.tipList}>
                {section.items.map(item => (
                  <div key={item} style={s.tipRow}>
                    <FontAwesomeIcon icon={faCircleCheck} style={s.tipIcon} aria-hidden="true" />
                    <span style={s.tipText}>{item}</span>
                  </div>
                ))}
              </div>
            ) : (
              <ul style={s.list}>
                {section.items.map(item => <li key={item} style={s.listItem}>{item}</li>)}
              </ul>
            )}
          </div>
        );
      })}
    </div>
  );
}

const s = {
  wrap: {
    display: 'flex', flexDirection: 'column', gap: 14, padding: 16,
    borderRadius: 16, background: 'var(--bg-secondary)', border: '1px solid var(--border-subtle)',
  },
  header: { display: 'flex', alignItems: 'center', gap: 8 },
  headerTitle: { fontSize: 12.5, fontWeight: 800, color: 'var(--text-primary)' },
  section: { display: 'flex', flexDirection: 'column', gap: 5 },
  sectionTitle: { fontSize: 10.5, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.5px' },
  list: { margin: '0 0 0 16px', padding: 0 },
  listItem: { fontSize: 12, color: 'var(--text-secondary)', lineHeight: 1.6 },
  tipList: { display: 'flex', flexDirection: 'column', gap: 8 },
  tipRow: { display: 'flex', alignItems: 'flex-start', gap: 7 },
  tipIcon: { color: 'var(--success)', fontSize: 11, marginTop: 3, flexShrink: 0 },
  tipText: { fontSize: 12, color: 'var(--text-secondary)', lineHeight: 1.55 },
};
